import React from 'react';
import { connect } from 'react-redux';
import Login from '../user/Login';

class UserPopup extends React.Component {
  onClick() {
    const { props } = this;
    props.alertUser();
  }

  render() {
    const { props } = this;
    const { user } = props;
    if (user && user.alert) {
      return (
        <div className="login-info">
          <Login />
          <div className="close-link" onClick={this.onClick.bind(this)} role="button"> close</div>
        </div>
      );
    }
    return '';
  }
}

const
  mapStateToProps = (state) => ({
    user: state.user,
  });

const
  mapDispatchToProps = (dispatch) => ({
    alertUser: () => {
      dispatch({
        type: 'ALERT_USER',
        alert: false,
      });
    },
  });

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserPopup);
